var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"generation-model-details",attrs:{"title":`实际生图模型：${_vm.model}`}},[_c('i',{staticClass:"el-icon-cpu"}),_c('b',[_vm._v("生图模型")]),_c('span',[_vm._v(_vm._s(_vm.model))])])
}
var staticRenderFns = []

export { render, staticRenderFns }